<template>
  <div class="flex items-center gap-6 lg:gap-4">
    <BtnText
      v-for="(locale, index) in locales"
      :key="index"
      size="lg"
      bold="semibold"
      :label="locale.name"
      :dark="props.dark"
      :active="currentLocale === locale.code"
      sub-title
      @click="changeLanguage(locale.code)"
    />
  </div>
</template>

<script setup lang="ts">
import BtnText from '@/shared/ui/components/button/BtnText.vue'
import { ref } from 'vue'
import { getLanguage, changeLanguage } from '@/features/change-language/lib/i18n'

type Props = {
  dark?: boolean
}
const props = defineProps<Props>()

const locales = ref<{ name: string; code: SupportedLocale }[]>([
  { name: 'KR', code: 'ko' },
  { name: 'EN', code: 'en' }
])
const currentLocale = ref<SupportedLocale>(getLanguage())
</script>
